import { render } from "./Userlist.vue?vue&type=template&id=5848f378&scoped=true"
import script from "./Userlist.vue?vue&type=script&lang=js"
export * from "./Userlist.vue?vue&type=script&lang=js"

import "./Userlist.vue?vue&type=style&index=0&id=5848f378&scoped=true&lang=scss"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5848f378"]])

export default __exports__